export default "__VITE_ASSET__BVB1Zgfq__"